<template>
<div class="chapter">
<div class="inner_page">
<p class="center">For my mother, <em class="italic">Je t’aime.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?fbdc00a8